import { colors } from "Constants";

export const tableContainerStyle = { padding: 0, margin: 0 };

export const editModeEmptyFieldStyles = {
  containerStyle: {
    border: 0,
  },
};

export const previewModeEmptyFieldStyles = {
  containerStyle: {
    border: `1px solid ${colors.strokeTwo}`,
  },
};
